import './sidebar.css'
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export default function Sidebar(){
    return(
        <aside className="aside">
            <div className='media_links'>
                <a className='social_media_icon_a' href='https://wa.me/+265880593391?text=I%20previewed%20your%20potiforio,%20are%20you%20ready%20to%20Code?'><WhatsAppIcon/></a>
                <a className='social_media_icon_a' href='https://instagram.com/_cyber_melvin_265?igshid=NGExMmI2YTkyZg=='><InstagramIcon/></a>
                
                <a className='social_media_icon_a' href='https://linkedin.com/in/melvin-kalidozo-b20a84225'><LinkedInIcon/></a>
                <a className='social_media_icon_a' href='https://github.com/Melvin-Kalidozo'><GitHubIcon/></a>
            </div>
       </aside>

        
    )
}